'use strict';

angular.module('shiftTraderApp')
  .controller('BaseSmartCWPCtrl', function BaseSmartCWPCtrl($scope, params, $filter,
                                                            $timeout, $interval, $log, $rootScope,
                                                            TimeService, WeightCalculationService) {
    var _this = this;

    $scope.currentDate = params.currentDate;
    $scope.adjustedCurrentDate = params.adjustedCurrentDate;
    $scope.allPositions = angular.copy(params.allPositions);
    $scope.allDepartments = _.map(angular.copy(params.allDepartments), function(dept) {
      dept.positions = _.where(dept.positions, {active: true});
      return dept;
    });
    $scope.allUsers = params.allUsers;
    $scope.me = params.me;
    $scope.org = params.org;

    $scope.weekRange = TimeService.getWeekTwixFromMoment($scope.currentDate, 0, 0, false);
    $scope.adjustedWeekRange = TimeService.getWeekTwixFromMoment($scope.currentDate, 0, 0, true);

    $scope.state = {
      recommendBarLoaded: false,
      writeIn: {
        calculationQueue: [],
        completedCalculations: [],
        writeInChangedTimeout: undefined,
        lastIntervalStart: null,
        calculationQueueInterval: undefined,
        showInput: false,
        usersPositionAdditions: {} // when a users_position item pushed onto user array with id:null, create user_id: [pos_id1, pos_id2]; when UP is actually created, remove pos_idx
      },
      itemLoadStates: {}
    };

    $scope.writeIn = {
      // define scope attribute for selected user/employee that is going to be added to a position and selected for shift
      selectedWriteInUser: null
    };

    this.animateEmployeeBoxToScrollPosition = function(scrollTopVal) {
      $('.base_smart_cwp_scroller').animate({
        scrollTop: scrollTopVal
      }, 300);
    };

    this.getSortedCurrentUsersList = function() {
      return $filter('orderBy')($scope.userListWithPosition, 'listRankingIndex');
    };

    this.calcAndSetUserLists = function(positionId) {
      // any time the shift changes, re-run this
      $log.log('calcAndSetUserLists');
      var t1 = [];
      var t2 = [];

      _.each($scope.allUsers, function(u) {
        if (u.$curMemb().active > 0) {
          if (_.any(u.users_positions, function(up) {
              return up.position_id === positionId;
            })) {
            t1.push(u);
          } else {
            t2.push(u);
          }
        }
      });

      $scope.userListWithPosition = t1;
      $scope.userListWithoutPosition = t2;

      $scope.state.itemLoadStates = {};

      _.each($scope.userListWithPosition, function(u) {
        $scope.state.itemLoadStates[u.id] = true; // designating that u.id is still calculating
      });
      $scope.$broadcast('sa:cwpLoadFinished', false);

    };

    this.clearOutUninitializedUsersPositions = function() {
      // remove users_positions w/ id:null from users before closing smart scheduling
      // id:null means that these people were added into list via write-in BUT weren't assigned
      _.forEach($scope.state.writeIn.usersPositionAdditions, function(positionIds, userId) {
        var u = _.find($scope.allUsers, {id: parseInt(userId)});
        if (u) {
          _.each(positionIds, function(posId) {
            var idx = _.findIndex(u.users_positions, {position_id: posId});
            if (idx > -1 && _.isNull(u.users_positions[idx].id)) {
              u.users_positions.splice(idx, 1);
            }
          });
        }
      });
    };

    $scope.$watch('writeIn.selectedWriteInUser', function(u) {
      if (!_.isNull(u)) {
        var user = _.find($scope.allUsers, {id: u.originalObject.id});
        // add the user to $scope.userListWithPosition if they are not there
        if (_.all($scope.userListWithPosition, function(usr) {
            return usr.id !== u.originalObject.id;
          })) {
          // add a users_position entry for the currentShift's position
          var theShiftPosition = _.find($scope.allPositions, { id: $scope.currentShift.position_id });

          var upData = {
            id: null,
            position_id: $scope.currentShift.position_id,
            user_id: user.id,
            organization_id: user.$curMemb().organization.id,
            active: true,
            hourly_wage: theShiftPosition.default_hourly_wage,
            training_hourly_wage: theShiftPosition.default_training_hourly_wage,
            training: false,
            ranking: 0
          };

          // push a users_position entry with id:null onto user
          user.users_positions.push(upData);
          if (!_.has($scope.state.writeIn.usersPositionAdditions, user.id)) {
            $scope.state.writeIn.usersPositionAdditions[user.id] = [];
          }
          $scope.state.writeIn.usersPositionAdditions[user.id].push(upData.position_id);
          _this.calcAndSetUserLists(upData.position_id);


          // scroll to row's position in list
          $timeout(function() {
            var allListItems = $('.base_smart_cwp_emp_list_item_wrapper');
            var singleHeight = allListItems.first().height();

            var e = $('#base_smart_cwp_emp_list_item-' + user.id);

            var idx = allListItems.index(e);

            $log.log('scrollHeight', e.position().top, singleHeight, idx);


            _this.animateEmployeeBoxToScrollPosition((idx - 2) * singleHeight);

            //highlight the row
            e.addClass('highlighted');

            // select that user for the shift automatically and display their card up top
            $rootScope.$broadcast('sa:employeeSelectedForInfo', user);
            $timeout(function() {
              e.removeClass('highlighted');
            }, 5000);
          }, 700);

          // clear out selectedWriteInUser
          $scope.writeIn.selectedWriteInUser = null;
          $scope.$broadcast('angucomplete-alt:clearInput', 'schedulingWriteIn');
        }
      }
    });


    $scope.writeIn.writeInOnFocusOutFn = function() {
      $log.log('writeInOnFocusOutFn');
      $scope.$broadcast('angucomplete-alt:clearInput', 'schedulingWriteIn');
    };

    $scope.writeIn.writeInChangedFn = function(val) {
      var that = this;
      if (!_.isUndefined($scope.state.writeIn.writeInChangedTimeout)) {
        $timeout.cancel($scope.state.writeIn.writeInChangedTimeout);
      }

      $scope.state.writeIn.writeInChangedTimeout = $timeout(function() {
        $log.log('writeInChangedFn $timeout exec', val, val.trim(), val.trim() == '');
        var startInterval = false;

        if (val.trim() == '' && $scope.state.writeIn.calculationQueueInterval) {
          $log.log('cancelling!');
          $interval.cancel($scope.state.writeIn.calculationQueueInterval);
        } else if (!_.isNull(val) || !_.isUndefined(val)){
          _.each(that.results, function(result) {
            if (!_.contains($scope.state.writeIn.completedCalculations, result.originalObject.id)) {
              $log.log('pushing ', result.originalObject.id, ' onto calculationQueue', result.originalObject.name);
              $scope.state.writeIn.calculationQueue.push(result.originalObject.id);
              startInterval = true;
            }
          });

          if (startInterval) {
            _this.startCalculationQueueInterval();
          }
        }
      }, 300);
    };

    $scope.$watchCollection(function() {
      if ($scope.currentShift) {
        return [$scope.currentShift.id, $scope.currentShift._type];
      } else {
        return [0, 0];
      }
    }, function(newVal, oldVal) {
      if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1]) {
        $scope.state.writeIn.completedCalculations = [];
      }
    });

    this.startCalculationQueueInterval = function() {
      $scope.state.writeIn.lastIntervalStart = moment.utc();
      $scope.state.writeIn.calculationQueueInterval = $interval(function() {
        //console.log('interval trigger');
        if ($scope.state.writeIn.calculationQueue.length > 0) {
          $log.log('calculativeQueue $interval non-zero', $scope.state.writeIn.calculationQueue);
          var x = $scope.state.writeIn.calculationQueue[0];
          _this.writeInRankingCalculation.calculateAvailabilityIndex(x);
          if ($scope.state.writeIn.calculationQueue[0] === x) {
            $scope.state.writeIn.calculationQueue.shift();

            if ($scope.state.writeIn.calculationQueue.length === 0 && $scope.state.writeIn.lastIntervalStart.isBefore(moment.utc())) {
              $interval.cancel($scope.state.writeIn.calculationQueueInterval);
            }

            $scope.state.writeIn.completedCalculations.push(x);
          }

        }
      }, 50);
    };

    this.writeInRankingCalculation = {};

    this.writeInRankingCalculation.calculateHoursPerWeek = function(userId) {
      // use date for beginning of work week to classify hours in each week
      // loop over workPeriods to do this
      return _.reduce(_.map(_.where($scope.relevantWorkPeriods, {user_id: userId}), function(wp) {
          if ($scope.adjustedWeekRange.overlaps(wp.range_twix)) {
            return Math.abs($scope.adjustedWeekRange.intersection(wp.range_twix).length('minutes')) / 60.0;
          } else {
            return 0;
          }
        }),
        function(num, sum) {
          return num + sum;
        }, 0);
    };

    this.writeInRankingCalculation.calculateAvailabilityIntersection = function(user) {
      var owa = user.$overlapsWithAvailability($scope.currentShift.range_twix);
      var blackout = Math.max.apply(Math, _.map(owa.data, function(v) {
        return (v.type === 'single' ? 1 : 0) + (v.approved && v.type === 'single' ? 2 : 0);
      }));

      if (blackout === -Infinity) {
        blackout = 0;
      }
      return [owa, blackout];
    };

    this.writeInRankingCalculation.calculateAvailabilityIndex = function(userId) {
      $log.log('calculateAvailabilityIndex', userId);
      var user = _.find($scope.allUsers, {id: userId});

      user._hoursThisWeek = _this.writeInRankingCalculation.calculateHoursPerWeek(userId);

      var currentTwixIntersectingWeekLengthInHours = $scope.currentShift.range_twix.intersection($scope.adjustedWeekRange).length('minutes') / 60.0;

      var userWorkPeriods = _.where($scope.relevantWorkPeriods, {user_id: userId});

      var results = {};

      results.availabilityIntersection = _this.writeInRankingCalculation.calculateAvailabilityIntersection(user);

      results.overlap = WeightCalculationService.calculateOverlapWithExistingWorkPeriods(
        userWorkPeriods,
        $scope.currentShift.range_twix);

      var targetHoursToUse = user.$effectiveAvailabilitySet($scope.currentShift.start_time) ? user.$effectiveAvailabilitySet($scope.currentShift.start_time).target_hours : 0;
      results.targetHours = WeightCalculationService.calculateTargetHoursWeighting(
        targetHoursToUse,
        user._hoursThisWeek,
        currentTwixIntersectingWeekLengthInHours);

      var overtimeHoursToUse = user.$curMemb().organization.organization_config.overtime_threshold_hours;
      results.overtime = WeightCalculationService.calculateOvertimeWeighting(
        overtimeHoursToUse,
        user._hoursThisWeek,
        currentTwixIntersectingWeekLengthInHours);

      //results.lastWeekWorkPeriod = evaluateIfLastWeek(shift);

      //results.timeOverlapWithLastWeek = evaluateIfTimeOverlapWithLastWeek(shift);

      results.availabilityIndex = results.overlap.weight + results.availabilityIntersection[0].weight +
      results.targetHours;// +
      //results.lastWeekWorkPeriod.weight + results.shiftGaps.weight;

      // if an employees target hours is > overtime hour threshold AND we are not penalizing that then don't add it in
      // line below is the exact reverse...
      if (user.$curMemb().organization.organization_config.penalize_target_gt_overtime === true || targetHoursToUse < overtimeHoursToUse) {
        results.availabilityIndex += results.overtime.weight;
      }

      //results.listRankingIndex = results.availabilityIndex - (results.lastWeekWorkPeriod.data.length > 0 ?
      //  (results.lastWeekWorkPeriod.data[0].matchType === -1 ? 100 : 50 ) : 0)
      //- results.timeOverlapWithLastWeek.weight;

      user._cssClasses = {};
      user._cssClasses[WeightCalculationService.getLabelColorForAvailabilityIndex(results.availabilityIndex, user._blackout)] = true;

      return results;
    };


    $scope.recommendBarMessages = [];

    this.sendRecommendBarMessages = function() {
      while($scope.recommendBarMessages.length > 0) {
        var msg = $scope.recommendBarMessages.shift();
        $rootScope.$broadcast('sa:cwpLoadFinished', msg);
      }
    };

    // we need to see this event before we start sending 'sa:cwpLoadFinished' messages, or else saSmartSchedRecommendBar won't preload correctly
    $scope.$on('sa:userRecommendBar:controllerInitCompleted', function(event) {
      $scope.state.recommendBarLoaded = true;
      _this.sendRecommendBarMessages();
    });


    this.broadcastCalcLoadFinished = function() {
      if (!$scope.state.recommendBarLoaded) {
        $scope.recommendBarMessages.push(_this.getSortedCurrentUsersList()[0]);
      } else {
        $rootScope.$broadcast('sa:cwpLoadFinished', _this.getSortedCurrentUsersList()[0]);
      }
    };


    function cwpEmployeeListingCalculationStateChanged(event, data) {
      if (event.stopPropagation) {
        event.stopPropagation();
      }

      // data.id is null when cwpEmployeeListItem is broadcasting the messages
      if (_.isNull(data.id) || ($scope.currentShift && data.id === $scope.currentShift.id && data.type === $scope.currentShift._type)) {
        if (data.state === true) {
          $scope.allListItemsLoaded = false;

          if ($scope.state.recommendBarLoaded) {
            $rootScope.$broadcast('sa:cwpLoadFinished', false);
          } else {
            $scope.recommendBarMessages.push(false);
          }

          $scope.state.itemLoadStates[data.user_id] = true; // still loading

        } else {
          $scope.state.itemLoadStates[data.user_id] = false; // still loading
        }

        if (lodash.every($scope.userListWithPosition, function(u) { return _.has($scope.state.itemLoadStates, u.id) && $scope.state.itemLoadStates[u.id] === false;})) {
          $scope.allListItemsLoaded = true;
          _this.broadcastCalcLoadFinished();
        } else {
          if ($scope.allListItemsLoaded) {
            $scope.allListItemsLoaded = false;
            $rootScope.$broadcast('sa:cwpLoadFinished', false);
          }

        }
      }

      if ($scope.state.recommendBarLoaded) {
        _this.sendRecommendBarMessages();
      }
    }

    this.cwpEmployeeListingCalculationStateChanged = cwpEmployeeListingCalculationStateChanged;
    $scope.$on('sa:cwpEmployeeListingCalculationState', cwpEmployeeListingCalculationStateChanged);

  });
